import { UserCancellationInterceptOutcomeTotalInterface } from "@vendor-app/domain/UserCancellationInterceptOutcomeTotalInterface";
import { UserCancellationInterceptOutcomeTotalsMapper } from "@vendor-app/mappers/UserCancellationInterceptOutcomeTotals/mapper";

import { typedFrontendVendorApi } from "@vendor-app/utils/typedFrontendVendorApi";

export default class UserCancellationInterceptOutcomeTotalsGateway {
  constructor(private readonly mapper: UserCancellationInterceptOutcomeTotalsMapper) {
    this.mapper = mapper;
  }

  public async fetch(dateRange: {
    start: Date;
    end: Date;
  }): Promise<UserCancellationInterceptOutcomeTotalInterface[]> {
    let result: UserCancellationInterceptOutcomeTotalInterface[] = [];

    const incrementedEndDate = new Date(dateRange.end);
    incrementedEndDate.setDate(incrementedEndDate.getDate() + 1);

    try {
      const response = await typedFrontendVendorApi.getReq("/user-cancellation-intercept-outcome-totals", {
        query: {
          startDate: dateRange.start.toISOString(),
          endDate: incrementedEndDate.toISOString(),
        },
      });

      if (response.type === "success") {
        result = this.mapper.mapData(response.body.data);
      }
    } catch (error) {
      console.error("Failed to fetch user cancellation intercept outcome totals:", error);
    }

    return result;
  }
}
